import {EventRepository} from "../js/event/EventRepository.js";
import {StructRepository} from "../js/struct/StructRepository.js";
import HeaderCmp from "./Header/HeaderCmp.js";
import HeaderMenuCmp from "./HeaderMenu/HeaderMenuCmp.js";
import TooltipManagerCmp from "./TooltipManager/TooltipManagerCmp.js";

export default class IndexPageDiContext {
    /** @type {Map<String, any>} */
    #singletons;

    /**
     * @param {HttpClient} httpClient
     */
    constructor(httpClient) {
        this.#singletons = new Map();
        this.#singletons.set('HttpClient', httpClient);
    }

    /** @returns {StructRepository} */
    getStructRepository() {
        return this.#getOrCreate('StructRepository', () => new StructRepository(this.getHttpClient()))
    }

    /** @returns {EventRepository} */
    getEventRepository() {
        return this.#getOrCreate('EventRepository', () => new EventRepository(this.getHttpClient()))
    }

    /** @returns {HeaderCmp} */
    getHeader() {
        return this.#getOrCreate('HeaderCmp', () => new HeaderCmp(this.getHeaderMenu()))
    }

    /** @returns {HeaderMenuCmp} */
    getHeaderMenu() {
        return this.#getOrCreate('HeaderMenuCmp', () => new HeaderMenuCmp())
    }

    /** @returns {TooltipManagerCmp} */
    getTooltipManager() {
        return this.#getOrCreate('TooltipManagerCmp', () => new TooltipManagerCmp())
    }

    getHttpClient() {
        return this.#getOrCreate('HttpClient');// it's initialized in the constructor
    }

    #getOrCreate(cmpName, createCmpFn) {
        let cmp = this.#singletons.get(cmpName);
        if(!cmp) {
            cmp = createCmpFn();
            this.#singletons.set(cmpName, cmp);
        }
        return cmp;
    }
}